export default __webpack_public_path__ + "static/media/tj_icon-blue.41120663.svg";